// extracted by mini-css-extract-plugin
export default {"mainImageDressContainer":"mainImageDress_mainImageDressContainer__xlJ43","arrows":"mainImageDress_arrows__UKndp","image":"mainImageDress_image__437Eb"};